// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Shared Toast Utility
// ═══════════════════════════════════════════════════════════════════════════
// Single implementation of the toast notification used across the app.
// Replaces the per-file copies (consolidation toward #63).
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Show a transient toast message. Accessible via role="status" so screen
 * readers announce it (#75).
 * @param {string} message
 * @param {{ duration?: number }} [options]
 */
export function showToast(message, { duration = 2500 } = {}) {
    const existing = document.querySelector('.toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(20px)';
        toast.style.transition = 'all 0.3s ease';
        setTimeout(() => toast.remove(), 300);
    }, duration);
}

export default { showToast };
